import {
  CHAT_USER_LIST,
  CHAT_USER_LIST_SEARCH,
  GET_ACTIVE_PROPERTY_LIST,
  GET_RECENT_CHAT_LIST,
  UPDATE_CHAT_STATUS,
} from "../types";

const initialState = {
  response: null,
  detail: false,
  create: false,
};

export function chatReducer(state = initialState, action) {
  switch (action.type) {
    case CHAT_USER_LIST:
      return {
        ...state,
        create: false,
        detail: false,
        response: action.payload,
      };
    case CHAT_USER_LIST_SEARCH:
      return {
        ...state,
        create: false,
        detail: false,
        searchResponse: action.payload,
      };
    case GET_RECENT_CHAT_LIST:
      return {
        ...state,
        create: false,
        detail: false,
        recentChatListResponse: action.payload,
      };
    case UPDATE_CHAT_STATUS:
      return {
        ...state,
        create: false,
        detail: false,
        // recentChatListResponse: action.payload,
      };
    case GET_ACTIVE_PROPERTY_LIST:
      return {
        ...state,
        create: false,
        detail: false,
        activeProperties: action.payload,
      };

    default:
      return state;
  }
}
